import {
  collection,
  getDocs,
  limit as limitFn,
  query,
  where,
} from "firebase/firestore";

/**
 * Turns a human title into a URL-safe slug.
 * Strips accents, lowercases, replaces whitespace with hyphens, caps length at 80.
 */
export function slugify(title) {
  if (!title) return "";
  return title
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);
}

/**
 * Checks whether a slug is already used in the given language by ANOTHER post.
 * Returns true if taken by a different post, false otherwise.
 */
export async function isSlugTaken(db, lang, slug, currentPostId) {
  if (!slug) return false;
  const field = lang === "es" ? "slugEs" : "slugEn";
  const q = query(
    collection(db, "blogPosts"),
    where(field, "==", slug),
    limitFn(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return false;
  return snap.docs[0].id !== currentPostId;
}
